<template>
  <div class="col-12 pl-2 pr-2 mb-2">
    <loading :active.sync="isLoading" :is-full-page="false"></loading>
    <div class="card" v-for="streamer in streamers">
      <div class="card-body">
        <div class="d-flex">
          <div>
            <strong>{{ streamer.name }}</strong><br>
            <span class="badge badge-danger mr-2" v-if="streamer.isRecording">Recording</span>
            <span class="badge badge-dark" v-if="streamer.isStreaming">Streaming</span>
          </div>
          <div class="ml-auto text-right">
            <button class="btn btn-success" @click="startStreaming(streamer.name)">
              <i class="fa fa-play"></i>
            </button>
            <button class="btn btn-danger ml-2"  @click="stopStreaming(streamer.name)">
              <i class="fa fa-stop"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--
         "type": "streamer",
      "name": "Cohs1",
      "isRecording": false,
      "isStreaming": false

    -->
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import { RepositoryFactory } from '../../../../../../../repositories/RepositoryFactory';

const DeviceControlRepository = RepositoryFactory.get('devicecontrol');

export default {
  name: 'StreamerDeviceTab',
  components: { Loading, DeviceControlRepository },
  data() {
    return {
      isLoading: true,
    };
  },
  async mounted() {
    await this.updateStatus();
  },
  computed: {
    streamers() {
	      if (this.$store.state.deviceControlList === null) {
		      return null;
	      }

      return this.$store.state.deviceControlList.filter(device => device.type === 'streamer');
    },
  },
  methods: {
    async applyPreset(encoderName, presetName) {
      this.isLoading = true;
      await DeviceControlRepository.apply(encoderName, presetName)
        .then((response) => {
          this.isLoading = false;
          this.$snotify.info(this.$t('UI_DEVICE_COMTROL_ENCODER_PRESET_APPLIED'));
        });
    },

    async startStreaming(deviceName) {
      this.isLoading = true;
      await DeviceControlRepository.startStreamer(deviceName).then((response) => {
        this.isLoading = false;
        this.$snotify.info(this.$t('UI_DEVICE_COMTROL_STREAMER_STARTED'));
        this.updateStatus();
      });
    },
    async stopStreaming(deviceName) {
      this.isLoading = true;
      await DeviceControlRepository.stopStreamer(deviceName).then((response) => {
        this.isLoading = false;
        this.$snotify.info(this.$t('UI_DEVICE_COMTROL_STREAMER_STOPPED'));
        this.updateStatus();
      });
    },

    async updateStatus() {
      this.isLoading = true;
      await DeviceControlRepository.list().then((response) => {
        this.isLoading = false;
        this.$store.commit('setDeviceControlList', response.data.devices);
      }).finally(() => this.isLoading = false);
    },
  },
};
</script>

<style scoped>

</style>
